// 这个部件导出给道诚那边用了，所以尽量和工作桌面解耦，不要依赖太多工作桌面的样式等等
import React, { Component } from "react";
import PropTypes from "prop-types";
import { Modal, Steps, Tabs, Input, Form, InputNumber, Select } from "antd";
import Ajax from "../../pub/js/ajax";
import Notice from "Components/Notice";
import { langCheck, isShowResolutionprompt, startIntro, getCookie } from "Pub/js/utils";
import "./index.less";
import { openPage } from "Pub/js/superJump";
import ACONE from "Assets/images/ac1.png";
import ACTWO from "Assets/images/ac2.png";
import ACTHREE from "Assets/images/ac3.png";
import { getStore, setStore } from "Pub/js/storageUtils";
import { getMulti } from "Pub/js/getMulti";
import "./intro.css";
const InputGroup = Input.Group;
const FormItem = Form.Item;
const Option = Select.Option;
import { createPortal } from 'react-dom';
import End from "../../widgets/NoviceGuide/end";
class AccountActivation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            isFirst: true,
            loginWay: "mobile",
            key: new Date().getTime().toString(),
            countryCodeNum: "86",
            num: 0,
            genCodeSuccess: false,
            step: 0,
            registUrl: "",
            phoneNum: "",
            imgUrl: "",
            bindInitStatus: 0,
            errorMsg: "",
            countryCode: [],
            showClassName: true,
            guideEndModal: false
        };
        this.closeResolutionprompt = null;
    }

    updateActivationPopState() {
        return new Promise((resolve, reject) => {
            Ajax({
                url: `/nccloud/baseapp/yht/bindinit.do`,
                info: {
                    name: langCheck("0000PUB-000211") /* 国际化处理： 首页*/,
                    action: langCheck("0000PUB-000212") /* 国际化处理： 首页激活弹窗*/
                },
                success: ({ data: { data } }) => {
                    resolve(data);
                },
                error: ({ data }) => {
                    const errorMsg = data.error ? data.error.message : langCheck("0000PUB-000367"); //友企联网关连接异常
                    this.setState({
                        visible: true,
                        bindInitStatus: 5,
                        errorMsg
                    });
                }
            });
        })

    }
    handleCancel = () => {
        // const { updateAPPDataStore } = this.props;
        this.setState({
            visible: false
        });
        // updateAPPDataStore && typeof (updateAPPDataStore) === 'function' && updateAPPDataStore();
        this.updateActivationPopState().then((data) => {
            // realStatus 为0  说明已实名认证
            if (+data.realStatus === 0) {
                setStore('isRealName', true);
            }
        })
    };
    // 下一步
    goNextPart = () => {
        if (this.state.bindInitStatus === 5) {
            this.showErrorMsg();
            return;
        }
        this.setState((prevState, props) => {
            if (prevState.step === 1) {
                return { step: prevState.step + 2 };
            } else {
                return { step: prevState.step + 1 };
            }
        });
    };
    // 切换登录方式
    switchLoginWay = () => {
        this.setState(prevState => ({
            loginWay: prevState.loginWay === "mobile" ? "email" : "mobile",
            countryCodeNum: "86"
        }));
    };
    // 图形验证码
    genImg = () => {
        let src = this.state.imgUrl + this.state.key;
        return <img id='picImg' src={src} onClick={this.refreshImg} />;
    };

    refreshImg = e => {
        let d = new Date().getTime().toString();
        this.setState({
            key: d
        });
        let src = this.state.imgUrl + d;
        e.target.src = src;
    };
    captchaCount = () => {
        let fun = () => {
            let num = this.state.num;
            if (num === 0) {
                // this.setState({ prompt: false });
                clearInterval(timer);
            } else {
                num--;
            }
            this.setState({ num });
        };
        let timer = setInterval(fun, 1000);
    };
    // 生成验证码
    genCode = () => {
        let ajaxData = {
            key: this.state.key,
            type: this.state.loginWay,
            countryCode: this.state.countryCodeNum
        };
        const { getFieldsValue, validateFields } = this.props.form;
        let accountLabel = this.state.loginWay === "email" ? "email" : "phone"; /* 国际化处理： 邮箱,手机号*/
        validateFields([accountLabel, "imgVerifyCode"], (errors, values) => {
            /* 国际化处理： 图形验证码*/
            if (errors) {
                return;
            } else {
                // ajaxData.account = ((accountLabel === '手机号') ? this.state.countryCodeNum : '' ) + values[accountLabel];
                ajaxData.account = values[accountLabel];
                ajaxData.code = values["imgVerifyCode"]; /* 国际化处理： 图形验证码*/

                Ajax({
                    url: "/nccloud/baseapp/yht/send.do",
                    info: {
                        name: langCheck("0000PUB-000216") /* 国际化处理： 友互通弹窗*/,
                        action: langCheck("0000PUB-000217") /* 国际化处理： 生成验证码*/
                    },
                    data: ajaxData,
                    success: function ({ data: { data } }) {
                        if (parseInt(data.status)) {
                            this.setState({
                                genCodeSuccess: true,
                                num: 60
                            });
                            this.captchaCount();
                        } else {
                            this.setState({
                                genCodeSuccess: false
                            });
                            document.getElementById("picImg").click();
                            Notice({
                                status: "error",
                                msg: data.msg
                            });
                        }
                    }.bind(this)
                });
            }
        });
    };
    // 成功消息提示 位置不确定
    successMessage = () => { };

    activeCode = () => {
        let ajaxData = {
            type: this.state.loginWay,
            countryCode: this.state.countryCodeNum
        };
        const { updateAPPDataStore } = this.props;
        const { getFieldsValue, validateFields } = this.props.form;
        let accountLabel = this.state.loginWay === "email" ? "email" : "phone"; /* 国际化处理： 邮箱,手机号*/
        validateFields([accountLabel, "imgVerifyCode", "verifyCode"], (errors, values) => {
            /* 国际化处理： 图形验证码,验证码*/
            if (errors) {
                return;
            } else {
                ajaxData.account = values[accountLabel];
                ajaxData.activeCode = values["verifyCode"]; /* 国际化处理： 验证码*/
                ajaxData.agreementcode = getCookie('agreementcode') || '';
                Ajax({
                    url: "/nccloud/baseapp/yht/bind.do",
                    info: {
                        name: langCheck("0000PUB-000216") /* 国际化处理： 友互通弹窗*/,
                        action: langCheck("0000PUB-000219") /* 国际化处理： 激活账号*/
                    },
                    data: ajaxData,
                    success: function ({ data: { data } }) {
                        if (parseInt(data.status)) {
                            this.goNextPart();
                            this.props.bindSuccess();
                            let STOREFORINFODATA = getStore("STOREFORINFODATA", true);
                            STOREFORINFODATA.needBind = false;
                            setStore("STOREFORINFODATA", STOREFORINFODATA, true);
                        }
                        Notice({
                            status: parseInt(data.status) ? "success" : "error",
                            msg: data.msg
                        });
                    }.bind(this)
                });
            }
        });
    };
    switchCountry = value => {
        this.setState({
            countryCodeNum: value
        });
    };
    // 手机号前缀部分
    renderTelPrefix = () => (
        <Select
            onChange={this.switchCountry}
            defaultValue={langCheck("0000PUB-000200")}
            dropdownMatchSelectWidth={false}>
            {/* 国际化处理： 中国*/}
            {
                this.state.countryCode.map(ele => (
                    <Option value={ele.key}>{ele.value}</Option>
                ))
            }
        </Select>
    );
    // 跳转到配置桌面
    handeleSkipPage = (uri, param) => {
        let { isOpen } = this.props;
        openPage(uri, false, param, ["b1", "b2", "b3"]);
        this.handleCancel();
    };
    // status为5时的错误提示.
    showErrorMsg = () => {
        Notice({
            status: "warning",
            msg: this.state.errorMsg
        });
    };
    handleAClick = () => {
        if (this.state.bindInitStatus === 5) {
            this.showErrorMsg();
        } else {
            window.open(this.state.registUrl, "_blank");
        }
    };
    // 新手引导提示
    startIntro = (cancel = true) => {
        cancel && this.handleCancel();
        const { is_cloud_register, deployType } = this.props;
        startIntro(() => {
            this.setState({
                guideEndModal: true
            })
        }, is_cloud_register, deployType);
    };
    render() {
        const { showClassName, guideEndModal } = this.state;
        const { getFieldDecorator, getFieldsValue, validateFields, setFieldsValue } = this.props.form;
        // 顶部状态栏
        const StatusBar = () => {
            const Step = Steps.Step;
            return (
                <Steps progressDot size='small' current={this.state.step} className='status-bar'>
                    <Step title={langCheck("0000PUB-000220")} />
                    {/* 国际化处理： 选择类型*/}
                    <Step title={langCheck("0000PUB-000221")} />
                    {/* 国际化处理： 绑定账户*/}
                    <Step title={langCheck("0000PUB-000222")} />
                    {/* 国际化处理： 激活成功*/}
                </Steps>
            );
        };
        // 根据state的步骤来判断渲染第几部分
        const partRender = step => {
            switch (step) {
                case 0:
                    return PartOne;
                    break;
                case 1:
                    return PartTwo();
                    break;
                case (2, 3):
                    return PartThree;
                    break;
                default:
                    return null;
            }
        };
        // 部分一 需要放图片
        const PartOne = (
            <div className='part-one'>
                <div>
                    <span onClick={this.handleAClick}>
                        <a>
                            <img src={ACONE} />
                        </a>
                    </span>
                    <span onClick={this.goNextPart}>
                        <img src={ACTWO} />
                    </span>
                </div>
                <div>
                    <p>{langCheck("0000PUB-000224")}</p>
                    {/* 国际化处理： 没有用友云账户，前往注册*/}
                    <p>{langCheck("0000PUB-000225")}</p>
                    {/* 国际化处理： 已有用友云账户，直接激活*/}
                </div>
            </div>
        );
        // 公用的样式
        const layout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 14 }
        };
        // 账号小模块
        const AccountPart = () => {
            let phoneNum = this.state.phoneNum;
            const emailInput = (
                <FormItem label={langCheck("0000PUB-000226")} {...layout}>
                    {/* 国际化处理： 邮箱账号*/}
                    {getFieldDecorator("email", {
                        /* 国际化处理： 邮箱*/
                        rules: [
                            {
                                type: "email",
                                message: langCheck("0000PUB-000227") /* 国际化处理： 输入不是有效的电子邮箱！*/
                            },
                            {
                                required: true,
                                message: langCheck("0000PUB-000228") /* 国际化处理： 请输入电子邮箱!*/
                            }
                        ],
                        validateTrigger: "onBlur"
                    })(<Input id='account' placeholder={langCheck("0000PUB-000229")} />)}
                    {/* 国际化处理： 请输入您的邮箱*/}
                </FormItem>
            );

            const mobileInput = (
                <div>
                    {this.renderTelPrefix()}
                    <span className='country-code-num'>+{this.state.countryCodeNum}</span>
                    <FormItem label={langCheck("0000PUB-000214")} {...layout}>
                        {getFieldDecorator("phone", {
                            /* 国际化处理： 手机号*/
                            rules: [
                                {
                                    pattern: +this.state.countryCodeNum === 86 && /[0-9]{11}/,
                                    message: langCheck("0000PUB-000230") /* 国际化处理： 输入不是有效的手机号！*/
                                },
                                {
                                    required: true,
                                    message: langCheck("0000PUB-000231") /* 国际化处理： 请输入手机号!*/
                                }
                            ],
                            validateTrigger: "onBlur",
                            initialValue: phoneNum
                        })(
                            <Input
                                className='mobile-input'
                                id='accountPhone'
                                placeholder={langCheck("0000PUB-000232")}
                            />
                        )}
                        {/* 国际化处理： 请输入手机号码*/}
                    </FormItem>
                </div>
            );
            switch (this.state.loginWay) {
                case "email":
                    return emailInput;
                    break;
                case "mobile":
                    return mobileInput;
                    break;
                default:
                    return null;
                    break;
            }
        };
        // 部分二 需要增加表单提交验证 成功后自动跳入第三部分.
        const PartTwo = () => {
            const TabPane = Tabs.TabPane;
            return (
                <div className='part-two'>
                    {/* 这次因为没有扫二维码功能 所以先暂时隐藏tabs */}
                    {/* <Tabs defaultActiveKey="1" tabBarStyle={{ width: "320px", margin: "0 auto"}}> */}
                    {/* <TabPane tab="账密激活" key="1"> */}

                    <div className='part-two-input-group'>
                        {AccountPart()}
                        <span className='switch-loginway-btn' onClick={this.switchLoginWay}>
                            <i className='iconfont icon-qiehuanyt' />
                            {this.state.loginWay === "email"
                                ? langCheck("0000PUB-000233")
                                : langCheck("0000PUB-000234")}
                            {/* 国际化处理： 切换至手机登录,切换至邮箱登录*/}
                        </span>
                    </div>
                    <div className='part-two-input-group'>
                        <FormItem label={langCheck("0000PUB-000215")} {...layout}>
                            {/* 国际化处理： 图形验证码*/}
                            {getFieldDecorator("imgVerifyCode", {
                                /* 国际化处理： 图形验证码*/
                                rules: [
                                    {
                                        required: true,
                                        message: langCheck("0000PUB-000235") /* 国际化处理： 请输入图形验证码!*/
                                    }
                                ]
                            })(<Input id='imgCode' placeholder={langCheck("0000PUB-000236")} />)}
                            {/* 国际化处理： 点击刷新验证码*/}
                        </FormItem>
                        {this.genImg()}
                    </div>
                    <div className='part-two-input-group'>
                        <FormItem label={langCheck("0000PUB-000218")} {...layout}>
                            {/* 国际化处理： 验证码*/}
                            {getFieldDecorator("verifyCode", {
                                /* 国际化处理： 验证码*/
                                rules: [
                                    {
                                        required: true,
                                        message: langCheck("0000PUB-000237") /* 国际化处理： 请输入验证码!*/
                                    }
                                ]
                            })(
                                <Input
                                    id='code'
                                    placeholder={this.state.genCodeSuccess ? langCheck("0000PUB-000238") : ""}
                                />
                            )}
                            {/* 国际化处理： 获取成功,请输入验证码*/}
                            <button
                                disabled={this.state.num === 0 ? false : true}
                                className='btn-getvcode'
                                onClick={this.genCode}>
                                {this.state.num === 0
                                    ? langCheck("0000PUB-000239")
                                    : this.state.num + langCheck("0000PUB-000240")}
                                {/* 国际化处理： 获取验证码,秒后重新获取*/}
                            </button>
                        </FormItem>
                    </div>
                    <div className='part-two-input-group'>
                        <label className='btn-label-pos' />
                        <button className='btn-active' onClick={this.activeCode}>
                            {langCheck("0000PUB-000241")}
                            {/* 国际化处理： 立即激活*/}
                        </button>
                    </div>
                    <div className='part-two-input-group'>
                        <label className='btn-label-pos' />
                        <button className='btn-register'>
                            <a href={this.state.registUrl} target='_blank'>
                                {langCheck("0000PUB-000242")}
                                {/* 国际化处理： 没有用友云账户，前往注册*/}
                            </a>
                        </button>
                    </div>
                    {/* </TabPane> */}
                    {/* <TabPane tab="扫码激活" key="2">
                            <div className="part-two-pic-group">
                                <img src=""/>
                                <p>请用友空间App扫描二维码登录
                                    <span className="btn-refresh">刷新</span>
                                </p>
                                <p className="part-two-link">
                                    <a href="">使用帮助</a>
                                    <a href="">下载友空间</a>
                                </p>
                            </div>
                        </TabPane> */}
                    {/* </Tabs> */}
                </div>
            );
        };
        // 部分三 需要更新图片
        const PartThree = (
            <div className='part-three'>
                <div>
                    <img src={ACTHREE} />
                </div>
                <div>
                    {/* 国际化处理： 您的账户已激活成功*/}
                    <p>{langCheck("0000PUB-000244")}</p>
                </div>
                <div className='btn-group'>
                    {/* <button
                        onClick={() => {
                            this.handeleSkipPage("/ds", { n: langCheck("0000PUB-000247") }); 
                        }}>
                        {langCheck("0000PUB-000248")}
                        配置桌面
                    </button> */}
                    {/* 立即体验 */}
                    <button onClick={this.startIntro}>{langCheck('0000PUB-000308')}</button>
                    {/* <button onClick={this.handleCancel}>{langCheck("0000PUB-000249")}</button> */}
                    {/* 国际化处理： 关闭*/}
                </div>
            </div>
        );
        return (
            <div>
                <Modal
                    title={langCheck("0000PUB-000250")} /* 国际化处理： 用友云账户激活*/
                    visible={this.state.visible}
                    footer={null}
                    closable={false}
                    maskClosable={true}
                    wrapClassName={`nc-account-activation ${(isShowResolutionprompt() && showClassName) ? 'nc-account-activation1' : ''}`}
                >
                    {StatusBar()}
                    {partRender(this.state.step)}
                </Modal>
                {guideEndModal && createPortal(<End
                    onClose={() => {
                        this.setState({ guideEndModal: false })
                    }}
                    onAgain={() => {
                        this.setState({ guideEndModal: false }, () => {
                            this.startIntro(false);
                        })
                    }}
                />, document.body)}
            </div>
        );
    }
    //获取国家代码
    getCountryCode = () => {
        Ajax({
            url: `/nccloud/platform/workbench/getcountrycode.do`,
            info: {
                name: langCheck('0000PUB-000105') /* 国际化处理： 首页*/,
                action: langCheck('0000PUB-000369') /* 国际化处理： 获取国家编码*/,
                appcode: "10228888" //必须写死，不然云原生环境接口会报错
            },
            success: ({ data: { data } }) => {
                this.setState({ countryCode: data });
            },
        });
    };

    componentWillMount() {
        if (!window.multiLang) {
            getMulti({
                moduleId: "0000PUB",
                domainName: "workbench",
                callback: json => {
                    window.multiLang = json;
                }
            });
        }
    }

    componentDidMount() {
        this.updateActivationPopState().then((data) => {
            switch (parseInt(data.status)) {
                case 0:
                    // 进入弹窗第一步;
                    this.setState({
                        visible: true,
                        registUrl: data.registUrl,
                        imgUrl: data.imgUrl
                    });
                    break;
                case 1:
                    // 进入弹窗第二步;
                    this.setState({
                        visible: true,
                        step: 1,
                        registUrl: data.registUrl,
                        phoneNum: data.mobile,
                        imgUrl: data.imgUrl
                    });
                    break;
                case 5:
                    // 弹出错误提示信息并不可操作
                    this.setState({
                        visible: true,
                        bindInitStatus: 5,
                        errorMsg: data.msg
                    });
                    break;
                default:
                    break;
            }
        });
        this.getCountryCode();
        this.closeResolutionprompt = PubSub.subscribe("closeResolutionprompt", () => {
            this.setState({
                showClassName: false
            })
        });
    }
    componentWillUnmount() {
        this.closeResolutionprompt && PubSub.unsubscribe(this.closeResolutionprompt); //移除订阅
    }
}
AccountActivation.propTypes = {
    bindSuccess: PropTypes.func.isRequired
};
// export default Form.create()(AccountActivation);
export default Form.create()(AccountActivation);
